var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFinnhub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.228516C6.331 0.228516 4.27637 2.35008 4.03922 4.95885C2.05739 5.19018 0.449997 6.73546 0.449997 8.77852C0.449997 10.9791 2.24273 12.7719 4.44334 12.7719H13.5611C15.7617 12.7719 17.55 10.9791 17.55 8.77852C17.55 6.73565 15.9468 5.19044 13.9652 4.95885C13.7281 2.35008 11.669 0.228516 9 0.228516ZM9.00222 3.40963C9.28722 3.40963 9.57222 3.60065 9.57222 3.98074V9.44918L10.8814 8.13773C11.4156 7.51419 12.3088 8.4074 11.6852 8.94152L9.40412 11.2215C9.29571 11.3312 9.14804 11.3926 8.99332 11.3896C8.84529 11.3875 8.70429 11.3262 8.60033 11.2215L6.32033 8.94152C5.69679 8.4074 6.58998 7.51419 7.12412 8.13773L8.43222 9.44584V3.98074C8.43222 3.60065 8.71722 3.40963 9.00222 3.40963Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinnhub);
export default __webpack_public_path__ + "static/media/iconFinnhub.6972dfdcc7a506d4c47c3d76798fa31b.svg";
export { ForwardRef as ReactComponent };